module.exports = __webpack_public_path__ + "static/media/cash.79c9d698.svg";